module.exports = __webpack_public_path__ + "img/game_bg3.1f551a2d.png";